import React from "react";
import { StateContext } from "../../../../Context/Context";
import { useContext } from "react";
import { FaXTwitter, FaLinkedin, FaGithub } from "react-icons/fa6";
import { github, linkedIn, twitter } from "../../../projectConfig";

export default function FixedRightSideBar() {
  const { state } = useContext(StateContext);

  return (
    <div className="absolute right-0 px-[2%] lg:!px-[4%]">
      <div
        className={`mt-[35vh] sm:mt-[30vh] flex flex-col gap-10 z-10 transition-all ${
          state.section !== "home" ? "opacity-0" : "opacity-1"
        }`}
      >
        <a href={github} target="_blank" rel="noopener noreferrer">
          <div className="rounded-full flex justify-center items-center w-[32px] h-[32px] sm:w-[50px] sm:h-[50px] backdrop-blur-[1px] bg-secondary/50">
            <FaGithub className="!text-base sm:!text-2xl" />
          </div>
        </a>
        <a href={linkedIn} target="_blank" rel="noopener noreferrer">
          <div className="rounded-full flex justify-center items-center w-[32px] h-[32px] sm:w-[50px] sm:h-[50px] backdrop-blur-[1px] bg-secondary/50">
            <FaLinkedin className="!text-base sm:!text-2xl" />
          </div>
        </a>
        <a href={twitter} target="_blank" rel="noopener noreferrer">
          <div className="rounded-full flex justify-center items-center w-[32px] h-[32px] sm:w-[50px] sm:h-[50px] backdrop-blur-[1px] bg-secondary/50">
            <FaXTwitter className="!text-base sm:!text-2xl" />
          </div>
        </a>
      </div>
    </div>
  );
}
